import Constants from '../constants';
function userValidated(state = false, action){
	switch(action.type){
		case 'VALIDATE_USER':
		return  Constants.password === action.password

		default : 
		return state;

	}
}

export default userValidated;


// WEBPACK FOOTER //
// ./src/js/reducers/userValidated.js